console.log('process.env.RBT_ENABLED', process.env.RBT_ENABLED);
if (process.env.NODE_ENV === 'development' && process.env.RBT_ENABLED === true) {
  require('./redBorderToolImpl');
}
